import {
    GET_AGENCIES_REQUEST,
    GET_AGENCIES_SUCCESS,
    GET_AGENCIES_FAILURE,
    SET_AGENCIES,
    SET_AGENCY,
    SUBMIT_AGENCY_REQUEST,
    SUBMIT_AGENCY_SUCCESS,
    SUBMIT_AGENCY_FAILURE
} from '../actions/agencies';
import { buildAgencies } from '../helpers/agencies';
const initialState = {
    agencies: [],
    agency: {},
    fetching: false,
    total: 0,
    submitFetching: false,
    submitSuccess: false
};

export default (state = initialState, action) => {
    switch (action.type) {
        case GET_AGENCIES_REQUEST: {
            return {
                ...state,
                fetching: true,
                submitSuccess: false
            };
        }
        case GET_AGENCIES_SUCCESS: {
            return {
                ...state,
                fetching: false,
                agencies: buildAgencies(action.payload.agencies, action.payload.companies, action.payload.dealers)
                ,
                total: action.payload.total !== 0 ? action.payload.total : state.total
            };
        }
        case GET_AGENCIES_FAILURE: {
            return {
                ...state,
                fetching: false
            };
        }
        case SET_AGENCIES: {
            return {
                ...state,
                agencies: action.payload.agencies,
                total: action.payload.total,
                fetching: !action.payload.agencies.length
            };
        }
        case SET_AGENCY: {
            return {
                ...state,
                agency: action.payload.agency
            };
        }
        case SUBMIT_AGENCY_REQUEST: {
            return {
                ...state,
                submitFetching: true,
                submitSuccess: false
            };
        }
        case SUBMIT_AGENCY_SUCCESS: {
            return {
                ...state,
                submitFetching: false,
                submitSuccess: true
            };
        }
        case SUBMIT_AGENCY_FAILURE: {
            return {
                ...state,
                submitFetching: false,
                submitSuccess: false
            };
        }
        default:
            return state;
    }
};
